/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegenerationTextResultDto } from '../../models/regeneration-text-result-dto';
import { RequestScheduleLogAiDto } from '../../models/request-schedule-log-ai-dto';

export interface DocumentAiV2ControllerGenerateScheduleLog$Params {
  centerId: any;
  type: 'user' | 'center';
      body: RequestScheduleLogAiDto
}

export function documentAiV2ControllerGenerateScheduleLog(http: HttpClient, rootUrl: string, params: DocumentAiV2ControllerGenerateScheduleLog$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerationTextResultDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiV2ControllerGenerateScheduleLog.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.query('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegenerationTextResultDto>;
    })
  );
}

documentAiV2ControllerGenerateScheduleLog.PATH = '/api/document-ai-v2/schedule-log-ai';
